import InProgressTable from "../components/inprogress-table/InProgressTable";

function Orders() {

    return  <InProgressTable/>
}

export default Orders;
